import type {
  ClientResponse,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/sessions/create-session'
import {
  handleFailure,
  handleSuccess,
  moduleName,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/sessions/create-session'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'

import { getConfig } from '../../../../config/configuration'

const { endpoints } = getConfig()

const args: RequestArgs<
  ServerResponse,
  ClientResponse,
  { matchedVolunteerId: string; parentRequestId: string }
> = {
  handleSuccess,
  handleFailure,
  method: 'POST',
  url: formatEndpoint(endpoints.api.v4.session),
}

const createSessionModule = () =>
  createReduxServiceModule<
    ServerResponse,
    ClientResponse,
    { matchedVolunteerId: string; parentRequestId: string }
  >({
    moduleName,
    args,
  })

export default createSessionModule
